import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import i18n from 'i18n-js';
import { withRouter, useParams } from 'react-router-dom';

import Layout from 'components/Layout';
import { buildUrl } from 'utils';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Wizard from 'components/UI/Wizard';
import { VehiclesTypesDetails } from 'components/VehiclesTypes/VehiclesTypesWizard';
import { uiActions } from 'state/modules/UI';
import { vehicleActions } from 'state/modules/vehicles';

import useStyles from './VehiclesTypesOnboarding.styled';

const VehiclesTypesOnboarding = ({ history }) => {
  const { id } = useParams();
  const classes = useStyles();
  const [showSaveAndExitModal, setShowSaveAndExitModal] = useState(false);
  const successMessage = `Vehicle type ${id ? 'updated' : 'created'} successfully`;

  const { fetchedVehicleTypeSuccess, loadingVehicleType, vehicleType, errors } = useSelector(
    (state) => state.vehicles
  );

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const setTitle = () => {
    if (id) {
      return `Vehicle type ID #${id}`;
    }
    return 'Create vehicle type';
  };

  useEffect(() => {
    if (id) {
      dispatch(vehicleActions.fetchVehicleTypeById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (fetchedVehicleTypeSuccess) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: successMessage,
        })
      );
      if (id) {
        return history.push(buildUrl(`/vehicle-types/${id}`));
      }
      history.push(buildUrl('/vehicle-types'));
    }
  }, [id, dispatch, history, successMessage, fetchedVehicleTypeSuccess]);

  const saveForm = () => {
    if (formRef?.current) {
      return formRef.current.submitForm();
    }
  };

  const handleEndOnboarding = () => {
    dispatch(vehicleActions.resetVehicleTypeOnboarding());
    history.push(buildUrl('/vehicle-types'));
  };

  const handleExit = (exit) => {};

  const handleShowOnSaveAndExitModal = () => {
    setShowSaveAndExitModal((prevState) => !prevState);
  };

  const vehicleTypeWizard = () => {
    return (
      <Box>
        <Wizard
          position={0}
          mode="create"
          exit={true}
          title={setTitle()}
          handleExit={handleExit}
          onNext={saveForm}
          loading={loadingVehicleType}
          successMessage={successMessage}
          saveButtonText={i18n.t('common.save')}
          handleEndOnboarding={handleEndOnboarding}
          showSaveAndExitModal={showSaveAndExitModal}
          customStepperClass={classes.stepperContainer}
          handleShowOnSaveAndExitModal={handleShowOnSaveAndExitModal}
        >
          <VehiclesTypesDetails vehicleType={vehicleType} formRef={formRef} errors={errors} />
        </Wizard>
      </Box>
    );
  };

  return (
    <Layout title="Dashboard">
      <Container maxwidth="lg">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              style={{ marginBottom: 48 }}
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                    {setTitle()}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {vehicleTypeWizard()}
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default withRouter(VehiclesTypesOnboarding);
